import { Link, useParams } from "react-router-dom";
import PageShell from "@/components/feature/PageShell";
import EmptyState from "@/components/base/EmptyState";
import StoryCard from "@/components/feature/StoryCard";
import ShareButtons from "@/components/feature/ShareButtons";
import { getCastById, getStoriesByIds } from "@/utils/catalog";

export default function CastDetailPage() {
  const { id } = useParams();
  const cast = getCastById(id);

  if (!cast) {
    return (
      <PageShell active="cast" crumbs={[{ label: "首页", to: "/" }, { label: "演员名单", to: "/category/cast" }, { label: "未找到" }]}>
        <EmptyState
          title="没有找到这位演员"
          description="资料可能已被调整，返回演员列表看看其他主创吧。"
          actionText="返回演员列表"
          onAction={() => window.REACT_APP_NAVIGATE("/category/cast")}
        />
      </PageShell>
    );
  }

  const works = getStoriesByIds(cast.storyIds);

  return (
    <PageShell
      active="cast"
      crumbs={[
        { label: "首页", to: "/" },
        { label: "演员名单", to: "/category/cast" },
        { label: cast.name },
      ]}
    >
      <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-7">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
          <div className="h-32 w-32 flex-shrink-0 overflow-hidden rounded-lg bg-background-100 sm:h-40 sm:w-40">
            <img
              src={cast.avatar}
              alt={`${cast.name}头像`}
              title={`${cast.name} 演员资料`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h1 className="font-heading text-2xl font-semibold text-foreground-900 md:text-3xl">{cast.name}</h1>
            <p className="mt-2 text-sm text-foreground-600">
              在剧中饰演 <span className="text-primary-600">{cast.role}</span>
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800">{cast.roleType}</span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                参与 {cast.storyIds.length} 段剧情
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{cast.roleIntro}</p>
          </div>
        </div>
      </div>

      <div className="mt-6 rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-7">
        <h2 className="font-heading text-lg font-semibold text-foreground-900">演员介绍</h2>
        <div className="mt-3 space-y-3">
          {cast.bio.map((paragraph, index) => (
            <p key={index} className="text-sm leading-loose text-foreground-600">
              {paragraph}
            </p>
          ))}
        </div>
        <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-5">
          <ShareButtons title={cast.name} />
          <Link
            to="/category/cast"
            className="inline-flex items-center gap-1 text-sm text-foreground-500 transition hover:text-primary-600"
          >
            <i className="ri-arrow-left-line"></i>返回演员列表
          </Link>
        </div>
      </div>

      {works.length > 0 && (
        <section className="mt-6">
          <h2 className="font-heading text-lg font-semibold text-foreground-900">参与剧情</h2>
          <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
            {works.slice(0, 6).map((story) => (
              <StoryCard key={story.id} story={story} />
            ))}
          </div>
        </section>
      )}
    </PageShell>
  );
}